import { css as p, LitElement as b, html as d } from "lit";
import { property as c, state as u, customElement as v } from "lit/decorators.js";
import { b as h, f as g } from "./styles-scZ6dVz-.js";
import "./ark-icon-TW_tZfDu.js";
var f = Object.defineProperty, y = Object.getOwnPropertyDescriptor, i = (e, r, n, t) => {
  for (var a = t > 1 ? void 0 : t ? y(r, n) : r, o = e.length - 1, l; o >= 0; o--)
    (l = e[o]) && (a = (t ? l(r, n, a) : l(a)) || a);
  return t && a && f(r, n, a), a;
};
const x = {
  platform: null,
  acme: "B68E88CF-0000-0000-0000-000000000001",
  nimbus: "A1B2C3D4-0000-0000-0000-000000000009",
  student: "ED0C0000-0000-0000-0000-000000000001"
}, m = [
  { id: "platform", name: "Platform", slug: "platform" },
  { id: "acme", name: "Acme Corp", slug: "acme" },
  { id: "nimbus", name: "Nimbus", slug: "nimbus" },
  { id: "student", name: "Student", slug: "student" }
], k = [
  {
    id: "sys-admin",
    name: "Sarah Chen",
    email: "sarah.chen@arctek.io",
    initials: "SC",
    avatar: "/assets/avatars/sarah-chen.jpg",
    role: "platform-admin",
    roleLabel: "Platform Admin",
    tenantId: "platform",
    returnUrl: "/dashboard/platform"
  },
  {
    id: "acme-admin",
    name: "Marcus Webb",
    email: "marcus.webb@acme-corp.com",
    initials: "MW",
    avatar: "/assets/avatars/marcus-webb.jpg",
    role: "tenant-admin",
    roleLabel: "Tenant Admin",
    tenantId: "acme",
    returnUrl: "/dashboard/tenant"
  },
  {
    id: "acme-engineer",
    name: "Elena Rodriguez",
    email: "elena.rodriguez@acme-corp.com",
    initials: "ER",
    avatar: "/assets/avatars/elena-rodriguez.jpg",
    role: "tenant-user",
    roleLabel: "Engineer",
    tenantId: "acme",
    returnUrl: "/dashboard/tenant"
  },
  {
    id: "acme-analyst",
    name: "James Park",
    email: "james.park@acme-corp.com",
    initials: "JP",
    avatar: "/assets/avatars/james-park.jpg",
    role: "tenant-user",
    roleLabel: "Analyst",
    tenantId: "acme",
    returnUrl: "/dashboard/tenant"
  },
  {
    id: "nimbus-admin",
    name: "Priya Sharma",
    email: "priya.sharma@nimbus.dev",
    initials: "PS",
    avatar: "/assets/avatars/priya-sharma.jpg",
    role: "tenant-admin",
    roleLabel: "Tenant Admin",
    tenantId: "nimbus",
    returnUrl: "/dashboard/tenant"
  },
  {
    id: "nimbus-lead",
    name: "David Kim",
    email: "david.kim@nimbus.dev",
    initials: "DK",
    avatar: "/assets/avatars/david-kim.jpg",
    role: "tenant-user",
    roleLabel: "Tech Lead",
    tenantId: "nimbus",
    returnUrl: "/dashboard/tenant"
  },
  {
    id: "student-alex",
    name: "Alex Torres",
    email: "alex.torres@university.edu",
    initials: "AT",
    avatar: "/assets/avatars/alex-torres.jpg",
    role: "student",
    roleLabel: "Student",
    tenantId: "student",
    returnUrl: "/dashboard/tenant"
  }
];
let s = class extends b {
  constructor() {
    super(...arguments), this.open = !1, this.visible = !1, this.redirectOnSuccess = !0, this.selectedTenant = m[0], this.selectedUser = null, this.handleKeydown = (e) => {
      this.open && e.key === "Escape" && (e.preventDefault(), this.close());
    };
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("keydown", this.handleKeydown), this.ensureSelectedUser();
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this.handleKeydown), super.disconnectedCallback();
  }
  willUpdate(e) {
    e.has("open") && this.open !== this.visible ? this.visible = this.open : e.has("visible") && this.visible !== this.open && (this.open = this.visible), e.has("selectedTenant") && this.ensureSelectedUser();
  }
  get availableUsers() {
    return k.filter((e) => e.tenantId === this.selectedTenant.id);
  }
  ensureSelectedUser() {
    const e = this.availableUsers;
    (!this.selectedUser || !e.some((r) => r.id === this.selectedUser?.id)) && (this.selectedUser = e[0] ?? null);
  }
  close() {
    this.open = !1, this.visible = !1, this.dispatchEvent(new CustomEvent("close", { bubbles: !0, composed: !0 }));
  }
  selectTenant(e) {
    this.selectedTenant = e, this.selectedUser = null;
  }
  selectUser(e) {
    this.selectedUser = e;
  }
  async performLogin() {
    if (!this.selectedUser) return;
    const e = this.selectedUser, r = x[this.selectedTenant.id];
    let n = "TenantUser";
    e.role === "platform-admin" ? n = "PlatformAdmin" : e.role === "tenant-admin" && (n = "TenantAdmin");
    try {
      const t = new URLSearchParams({
        role: n,
        email: e.email,
        returnUrl: e.returnUrl
      });
      r && t.append("tenantId", r);
      const a = `/api/dev/auth/login?${t.toString()}`, o = await fetch(a, {
        method: "POST",
        credentials: "include",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json, text/plain, */*"
        }
      });
      o.ok ? (this.dispatchEvent(new CustomEvent("dev-login-success", {
        detail: {
          user: e,
          role: n,
          tenantId: r,
          returnUrl: e.returnUrl
        },
        bubbles: !0,
        composed: !0
      })), this.redirectOnSuccess && (window.location.href = e.returnUrl)) : console.error("Dev login failed:", o.status);
    } catch (t) {
      console.error("Dev login error:", t);
    }
  }
  renderTenantButton(e) {
    const r = this.selectedTenant.id === e.id;
    return d`
      <button
        class="tenant-button focus-ring"
        data-selected=${r ? "true" : "false"}
        type="button"
        @click=${() => this.selectTenant(e)}
      >
        ${e.name}
      </button>
    `;
  }
  renderUserButton(e) {
    const r = this.selectedUser?.id === e.id;
    return d`
      <button
        class="user-button focus-ring"
        data-selected=${r ? "true" : "false"}
        type="button"
        @click=${() => this.selectUser(e)}
      >
        <span class="avatar" title=${e.name}>${e.initials}</span>
        <div class="user-info">
          <div class="user-name">${e.name}</div>
          <div class="user-email">${e.email}</div>
        </div>
        <div class="role-badge" data-role=${e.role}>${e.roleLabel}</div>
      </button>
    `;
  }
  render() {
    const e = this.selectedUser?.name.split(" ")[0] || "...";
    return d`
      <div class="overlay" aria-hidden=${!(this.open || this.visible)}>
        <div class="backdrop" @click=${this.close}></div>
        <div class="modal" role="dialog" aria-modal="true" aria-labelledby="dev-login-title">
          <div class="header">
            <div class="header-title">
              <div class="header-icon">
                <ark-icon name="terminal" size="sm"></ark-icon>
              </div>
              <div>
                <h2 id="dev-login-title">Development Login</h2>
                <p>Select a test identity to assume</p>
              </div>
            </div>
            <button class="close-button focus-ring" type="button" @click=${this.close}>
              <ark-icon name="x" size="sm"></ark-icon>
            </button>
          </div>

          <div class="section">
            <label class="section-label">Environment</label>
            <div class="tenant-grid">
              ${m.map((r) => this.renderTenantButton(r))}
            </div>
          </div>

          <div class="user-section">
            <label class="section-label">Test User</label>
            <div class="user-list">
              ${this.availableUsers.map((r) => this.renderUserButton(r))}
            </div>
          </div>

          <div class="footer">
            <p class="shortcut">
              <kbd>Ctrl</kbd>
              +
              <kbd>9</kbd>
              to toggle
            </p>
            <div class="footer-actions">
              <button class="btn btn-secondary focus-ring" type="button" @click=${this.close}>
                Cancel
              </button>
              <button
                class="btn btn-primary focus-ring"
                type="button"
                ?disabled=${!this.selectedUser}
                @click=${this.performLogin}
              >
                Sign In as ${e}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }
};
s.styles = [
  h,
  g,
  p`
      :host {
        display: contents;
        color: var(--r5-text);
      }

      .overlay {
        position: fixed;
        inset: 0;
        z-index: var(--r5-z-overlay, 50);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        opacity: 0;
        pointer-events: none;
        transition: opacity 200ms ease;
      }

      :host([open]) .overlay,
      :host([visible]) .overlay {
        opacity: 1;
        pointer-events: auto;
      }

      .backdrop {
        position: absolute;
        inset: 0;
        background: color-mix(in oklch, var(--r5-bg) 80%, transparent);
        backdrop-filter: blur(4px);
      }

      .modal {
        position: relative;
        width: 100%;
        max-width: 36rem;
        height: min(560px, calc(100vh - 2rem));
        display: flex;
        flex-direction: column;
        border-radius: var(--r5-radius-base);
        border: 1px solid var(--r5-border);
        background: var(--r5-surface);
        box-shadow: var(--r5-shadow-popover, 0 25px 50px -12px rgba(0, 0, 0, 0.25));
        overflow: hidden;
        opacity: 0;
        transform: scale(0.95);
        transition: opacity 200ms ease, transform 200ms ease;
      }

      :host([open]) .modal,
      :host([visible]) .modal {
        opacity: 1;
        transform: scale(1);
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 1.5rem;
        border-bottom: 1px solid var(--r5-border);
      }

      .header-title {
        display: flex;
        align-items: center;
        gap: 0.75rem;
      }

      .header-icon {
        width: 2rem;
        height: 2rem;
        border-radius: var(--r5-radius-base);
        background: var(--r5-muted);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--r5-text-muted);
      }

      .header-title h2 {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
        color: var(--r5-text);
      }

      .header-title p {
        margin: 0.125rem 0 0;
        font-size: 0.75rem;
        color: var(--r5-text-muted);
      }

      .close-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.25rem;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        border-radius: var(--r5-radius-sm);
        cursor: pointer;
        transition: color 150ms ease, background-color 150ms ease;
      }

      .close-button:hover {
        color: var(--r5-text);
        background: color-mix(in oklch, var(--r5-muted) 50%, transparent);
      }

      .section {
        padding: 1rem 1.5rem;
        border-bottom: 1px solid color-mix(in oklch, var(--r5-border) 50%, transparent);
      }

      .section-label {
        display: block;
        font-size: 0.75rem;
        font-weight: 500;
        color: var(--r5-text-muted);
        text-transform: uppercase;
        letter-spacing: 0.025em;
      }

      .tenant-grid {
        margin-top: 0.5rem;
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 0.5rem;
      }

      .tenant-button {
        padding: 0.5rem 0.75rem;
        border-radius: var(--r5-radius-base);
        border: 1px solid var(--r5-border);
        background: color-mix(in oklch, var(--r5-muted) 30%, transparent);
        color: var(--r5-text-muted);
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
      }

      .tenant-button:hover {
        border-color: color-mix(in oklch, var(--r5-primary) 50%, transparent);
        background: color-mix(in oklch, var(--r5-muted) 50%, transparent);
      }

      .tenant-button[data-selected='true'] {
        border-color: var(--r5-primary);
        background: color-mix(in oklch, var(--r5-primary) 10%, transparent);
        color: var(--r5-primary);
      }

      .user-section {
        flex: 1;
        min-height: 0;
        padding: 1rem 1.5rem;
        overflow-y: auto;
        scrollbar-width: none;
      }

      .user-section::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      .user-list {
        margin-top: 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }

      .user-button {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.75rem 1rem;
        border-radius: var(--r5-radius-base);
        border: 1px solid var(--r5-border);
        background: color-mix(in oklch, var(--r5-muted) 20%, transparent);
        text-align: left;
        cursor: pointer;
        transition: border-color 150ms ease, background-color 150ms ease;
      }

      .user-button:hover {
        border-color: color-mix(in oklch, var(--r5-primary) 50%, transparent);
        background: color-mix(in oklch, var(--r5-muted) 30%, transparent);
      }

      .user-button[data-selected='true'] {
        border-color: var(--r5-primary);
        background: color-mix(in oklch, var(--r5-primary) 10%, transparent);
      }

      .avatar {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 9999px;
        border: 1px solid var(--r5-border);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.75rem;
        font-weight: 600;
        color: var(--r5-text-muted);
        background: color-mix(in oklch, var(--r5-primary) 12%, transparent);
        user-select: none;
      }

      .user-info {
        min-width: 0;
        flex: 1;
      }

      .user-name {
        font-size: 0.875rem;
        font-weight: 500;
        color: var(--r5-text);
      }

      .user-email {
        font-size: 0.75rem;
        color: var(--r5-text-muted);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .role-badge {
        padding: 0.125rem 0.5rem;
        border-radius: var(--r5-radius-sm);
        font-size: 0.6875rem;
        font-weight: 500;
      }

      .role-badge[data-role='platform-admin'],
      .role-badge[data-role='tenant-admin'] {
        background: color-mix(in oklch, var(--r5-primary) 10%, transparent);
        color: var(--r5-primary);
      }

      .role-badge[data-role='tenant-user'] {
        background: color-mix(in oklch, var(--r5-success) 10%, transparent);
        color: var(--r5-success);
      }

      .role-badge[data-role='student'] {
        background: var(--r5-muted);
        color: var(--r5-text-muted);
      }

      .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 1.5rem;
        border-top: 1px solid var(--r5-border);
        background: color-mix(in oklch, var(--r5-muted) 20%, transparent);
      }

      .shortcut {
        margin: 0;
        font-size: 0.6875rem;
        color: var(--r5-text-muted);
      }

      .shortcut kbd {
        padding: 0.125rem 0.375rem;
        border-radius: var(--r5-radius-sm);
        border: 1px solid var(--r5-border);
        background: var(--r5-muted);
        font-size: 0.625rem;
        font-family: var(--r5-font-mono);
      }

      .footer-actions {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.375rem 0.75rem;
        border-radius: var(--r5-radius-base);
        border: 1px solid transparent;
        font-size: 0.875rem;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
      }

      .btn-secondary {
        border-color: var(--r5-border);
        background: transparent;
        color: var(--r5-text-muted);
        font-weight: 500;
      }

      .btn-secondary:hover {
        background: var(--r5-muted);
      }

      .btn-primary {
        background: var(--r5-primary);
        color: white;
      }

      .btn-primary:hover {
        background: color-mix(in oklch, var(--r5-primary) 90%, transparent);
      }

      .btn-primary:disabled {
        background: var(--r5-muted);
        color: var(--r5-text-muted);
        cursor: not-allowed;
      }

      @media (max-width: 640px) {
        .modal {
          height: min(560px, calc(100vh - 1.5rem));
        }

        .tenant-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }
    `
];
i([
  c({ type: Boolean, reflect: !0 })
], s.prototype, "open", 2);
i([
  c({ type: Boolean, reflect: !0 })
], s.prototype, "visible", 2);
i([
  c({ type: Boolean, attribute: "redirect-on-success" })
], s.prototype, "redirectOnSuccess", 2);
i([
  u()
], s.prototype, "selectedTenant", 2);
i([
  u()
], s.prototype, "selectedUser", 2);
s = i([
  v("ark-dev-login-modal")
], s);
export {
  s as A
};
//# sourceMappingURL=ark-dev-login-modal-C4jOPml4.js.map
